// Food menu data for The Rusty Nail - drives the UI for easy updates
export const appetizers = [
  {
    name: "Smoked Brisket Queso Skillet",
    desc: "Queso Blanco topped with smoked brisket & fresh pico and made to order chips",
    img: "5642.webp",
  },
  {
    name: "Chips and Queso",
    desc: "Hand cut and made to order side of queso blanco",
  },
  {
    name: "Smoked Brisket Sliders (3)",
    desc: "House smoked brisket served on toasted Hawaiian roll with house “Rusty” BBQ sauce, pickle, and fried onion strings (side jalapeño)",
    img: "5254.webp",
  },
  {
    name: "Fried Pickles",
    desc: "Served with a side of house smoked gouda ranch",
  },
  {
    name: "Smoked Mozzarella Cheese Bites",
    desc: "Made fresh to order in our special blend of seasonings, served with a side of marinara sauce.",
    img: "5005.webp",
  },
  {
    name: "Cauliflower Florets",
    desc: "Lightly breaded florets with house smoked gouda ranch side of buffalo sauce.",
  },
  {
    name: "Brussel Sprouts",
    desc: "Crispy Sprouts dressed with a balsamic drizzle, parmesan cheese, topped with fresh bacon, sea salt, cracked pepper and a side of house jalapeno tomato jam",
    img: "2252.webp",
  },
  {
    name: "Chicken Tenders",
    desc: "House battered hand cut with fries and a side of house made honey mustard",
  },
  {
    name: "Fish Tacos (3)",
    desc: "Seared white fish topped with pineapple pico, drizzle of house spicy mayo and Cotija cheese crumbles",
    img: "2829.webp",
  },
  {
    name: "White Truffle Fries",
    desc: "White truffle oil, cracked pepper, sea salt, and topped with parmesan cheese",
  },
  {
    name: "Sweet Taters",
    desc: "Served with a side of local Texas honey",
  },
  {
    name: "Fried Okra",
    desc: "Served with house smoked Gouda ranch",
  },
  {
    name: "Fried Portabella Mushrooms",
    desc: "Made fresh to order with our house smoked gouda ranch served on the side",
  },
];

export const burgers = [
  {
    name: "Classic Cheeseburger",
    desc: "Served with Fries",
    img: "4921.webp",
    note: "8 oz. angus patty cooked medium, American & cheddar, brioche bun. Veggies on side. Side of house habanero mango ketchup.",
  },
  {
    name: "Portabella Mushroom Swiss Burger",
    desc: "Swiss cheese and sautéed mushrooms served with fries",
  },
  {
    name: "BBQ Bacon Burger",
    desc: "Stacked with onion rings, Brisket, bacon, drizzled with Rusty BBQ sauce and served with fries",
    img: "0018.webp",
  },
  {
    name: "Chicken on a Stick",
    desc: "Over sized, pickle brined marinated in smoked buttermilk hand battered chicken breast served with a sweet Hawaiian roll, pickled jalapeno, and sweet Thai chili",
  },
  {
    name: "Grilled Chicken Sandwich",
    desc: "8 oz. chicken breast topped with Swiss cheese served with boom boom sauce and fries",
  },
];

export const foodNote = "*8 oz. angus patty cooked medium, both American and cheddar, brioche bun. Veggies on side. Side of house habanero mango ketchup for burgers.";
